/**
 * Created by mykurisu on 2017/8/14.
 */
import React from 'react';
import axios from 'axios';
import {connect} from 'react-redux'
import {ClickLoadMore} from '../../components'
import BanListItem from './BanListItem'
import BanNone from '../../images/ban-no-item.png'

class BanList extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            offset: this.props.liveroomSetting.liveroomBan.next_offset,
            searchParams:this.props.searchParams
        }
    }

    componentDidMount() {
        const {liveroomSetting} = this.props;
        this.ban_scroll_method = () => {
            let allScrollTop = document.documentElement.scrollTop || window.pageYOffset || document.body.scrollTop;
            let shouldGet = document.body.offsetHeight - allScrollTop  <= window.screen.height + 100;
            let id = this.props.liveroomSetting.liveroom_id;
            if (shouldGet && this.props.liveroomSetting.liveroomBanInit && this.props.liveroomSetting.liveroomBan.has_more){
                if (!this.state.loading){
                    this.setState({
                        loading: true
                    });
                    //GET LECTURE MORE
                    axios.get(`/api/liveroom/${id}/block/list`,{
                        params: Object.assign({
                            offset: this.props.liveroomSetting.liveroomBan.next_offset,
                        }, this.props.searchParams)
                    })
                        .then(res => {
                            if (res.data.code === 0){
                                this.setState({
                                    loading: false
                                });
                                let list = this.props.liveroomSetting.liveroomBanList.concat(res.data.data.accounts);
                                this.props.dispatch({
                                    type: 'LIVEROOM_BAN_INIT',
                                    payload: res.data.data
                                });
                                this.props.dispatch({
                                    type: 'LIVEROOM_BAN_LIST',
                                    payload: list
                                });
                            }
                        })
                }
            }
        };

        window.addEventListener('scroll',this.ban_scroll_method);
    }

    componentWillUnmount (){
        this.props.dispatch({
            type: 'LIVEROOM_BAN_CLEAR'
        });
        this.ban_scroll_method && window.removeEventListener('scroll',this.ban_scroll_method);
    }

    render() {
        const {liveroomSetting} = this.props;
        const loadingstatus = {
            ended: liveroomSetting.liveroomBanInit && !liveroomSetting.liveroomBan.has_more,
            loading: this.state.loading,
            has_more: liveroomSetting.liveroomBanInit && liveroomSetting.liveroomBan.has_more,
            loadMethod: () => {}
        };
        return (
            <div className="ban-page-list">
                {liveroomSetting.liveroomBanList.length === 0 &&
                <div className="ban-page-list-none">
                    <img src={BanNone} alt=""/>
                    <p>当前列表暂无数据</p>
                </div>
                }
                {liveroomSetting.liveroomBanList.length !== 0 &&
                liveroomSetting.liveroomBanList.map((item) => <BanListItem itemType={'ban'} content={item} key={item.id}/>)
                }
                {liveroomSetting.liveroomBanList.length !== 0 &&
                <ClickLoadMore loadingstatus={loadingstatus}/>
                }
            </div>
        )
    }
}

export default connect(state => ({
    liveroomSetting: state.liveroomSetting
}))(BanList)


// WEBPACK FOOTER //
// ./src/components/liveroomLecturer/BanList.js